import { useTradingViewWidget } from './useTradingViewWidget';

const SYMBOLS = [
  { proName: 'FOREXCOM:SPXUSD', title: 'S&P 500' },
  { proName: 'FOREXCOM:NSXUSD', title: 'Nasdaq 100' },
  { proName: 'FOREXCOM:UKXGBP', title: 'FTSE 100' },
  { proName: 'NASDAQ:AAPL', title: 'Apple' },
  { proName: 'NASDAQ:NVDA', title: 'NVIDIA' },
  { proName: 'NASDAQ:MSFT', title: 'Microsoft' },
  { proName: 'NASDAQ:TSLA', title: 'Tesla' },
  { proName: 'LSE:SHEL', title: 'Shell' },
  { proName: 'LSE:VOD', title: 'Vodafone' },
];

export function TickerTape() {
  const ref = useTradingViewWidget('embed-widget-ticker-tape', {
    symbols: SYMBOLS,
    showSymbolLogo: true,
    colorTheme: 'dark',
    isTransparent: true,
    displayMode: 'adaptive',
    locale: 'en',
  });

  // Hide on small screens — sticky-header weight is the biggest mobile pain
  // point per the mobile audit. The TV iframe also renders taller than
  // declared, so clipping is misleading. Better: don't show it.
  return (
    <div
      ref={ref}
      className="tradingview-widget-container w-full overflow-hidden hidden md:block"
      style={{ minHeight: 72 }}
    />
  );
}
